export default __webpack_public_path__ + "src/public/FallenRocket.svg";